import { useContext } from "react";

import { EditBoardPropertiesContext } from "./EditBoardPropertiesContext";

export function useEditBoardProperties() {
  const context = useContext(EditBoardPropertiesContext);
  if (!context) {
    throw new Error("useEditBoardProperties must be used within a EditBoardPropertiesProvider");
  }
  return context;
}
